var render = function render(){var _vm=this,_c=_vm._self._c;return _c('layout',{staticClass:"text-white"},[_c('section-contact-form',{attrs:{"id":"section-contact-form","section-contact-form":_vm.sectionContactForm,"contact-info":_vm.contact}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }